// マスコットのひとりごと（ランダムトーク）
// hoursを指定すると、その時間帯だけ候補に入る（fromが大きい場合は日跨ぎ）
interface TalkLine {
  text: string;
  hours?: [from: number, to: number];
}

const TALK_LINES: TalkLine[] = [
  { text: 'ふふ、ここにいるよ' },
  { text: '一緒にいられて嬉しいな' },
  { text: 'お水、ちゃんと飲んでる？' },
  { text: 'んーっ、伸びをすると気持ちいいよ' },
  { text: '無理しなくていいからね' },
  { text: '今日のあなたも、えらいよ' },
  { text: 'なでなでしてくれてもいいんだよ？' },
  { text: 'ドーナツ、食べたいなあ' },
  { text: 'たまには遠くを見て、目を休めてね' },
  { text: '深呼吸しよ？　すー、はー' },
  { text: 'あなたのペースでいいんだよ' },
  { text: 'ゴミゴミダンス…ふふ、なんでもないよ' },
  { text: '肩の力、ぬけてる？' },
  { text: '60点でも、1点でも、前に進んでるよ' },
  { text: 'おはよう！今日ものんびりいこうね', hours: [5, 11] },
  { text: '朝の空気って気持ちいいよね', hours: [5, 11] },
  { text: 'お昼過ぎは眠くなるよね…ふぁ…', hours: [13, 16] },
  { text: '今日も一日、おつかれさま', hours: [18, 23] },
  { text: '夜は無理しないでね', hours: [21, 24] },
  { text: 'そろそろ夜更かしさんかも？　休むのも大事だよ', hours: [0, 5] },
];

const inHours = (hour: number, [from, to]: [number, number]) =>
  from <= to ? hour >= from && hour < to : hour >= from || hour < to;

export const pickMascotTalk = (): string => {
  const hour = new Date().getHours();
  const pool = TALK_LINES.filter((l) => !l.hours || inHours(hour, l.hours));
  return pool[Math.floor(Math.random() * pool.length)].text;
};
